<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title"><b>Retornos</b></h3>
                    </div>

                    <div class="box-body">
                        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>



                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 5%;">ID</th>
                                            <th style="width: auto;">Qt. Liquidados</th>
                                            <th style="width: auto;">Liquidados (R$)</th>
                                            <th style="width: auto;">Qt. Baixados</th>
                                            <th style="width: auto;">Baixados (R$)</th>
                                             <th style="width: auto;">Qt. Disp. Pagamento</th>
                                            <th style="width: auto;">Disp. Pagamento (R$)</th>
                                            <th style="width: auto;">Arquivo</th>
                                            <th style="width: 15%;">Submetido por</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                                            <td>{{ item.id }}</td>
                                             <td>{{ item.quantidade_liquidado }}</td>
                                            <td>{{ item.total_valor_liquidado | numberFormat(2,',','.') }}</td>
                                            <td>{{ item.quantidade_baixa }}</td>
                                            <td>{{ item.total_valor_baixa | numberFormat(2,',','.') }}</td>
                                             <td>{{ item.quantidade_entrada }}</td>
                                            <td>{{ item.total_valor_entrada | numberFormat(2,',','.') }}</td>
                                            <td>{{ item.arquivo }}</td>
                                            <td>{{ item.usuario.name  }} em {{ item.created_at | dataHoraFormatada  }}</td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class='col-sm-5'>
                                        Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
                                    </div>

                                    <div class='col-sm-7' style="text-align:right">
                                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div> <!-- /.box-body -->




                </div> <!-- /.box -->
            </div> <!-- /.col-md-12 -->
        </div> <!-- /.row -->
    </section>
</template>
<script>

import axios from 'axios' // Cliente para requisição http
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {

    data() {
        return {
            dropzoneOptions: {
                url: `${this.$store.state.serverURI}/api/retorno/create`,
                method: 'POST',
                maxFiles: 1,
                maxFilesize: 500,
                timeout: 99999999999999,
                autoQueue: true,
                parallelUploads: 2,
                paramName: 'arquivo', 
                dictDefaultMessage: 'Adicione aqui o arquivo de retorno a ser processado...',
                dictResponseError: 'Servidor não configurado!',
                acceptedFiles: '.txt',
                headers: this.$store.getters.getHeaderAuthFile,
                withCredentials: true,
                success: (value) => { this.getDataTable() }
            },
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },
            dataTable: {}
        }
    },
    mounted () {
        this.getDataTable();
    },

    methods: {
        getDataTable (page) {
            if (typeof page === 'undefined') {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit('TOGGLE_LOADING');
            
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            console.log(this.filtros);
            axios.get(`${this.$store.state.serverURI}/api/retorno/getAllPaginate`, config)
            .then(response => {
                this.dataTable = response.data;
                this.$store.commit('TOGGLE_LOADING');
            }).catch((error) => { this.$store.commit('throwException', error); });          

        },
    },
    watch: {

    },

    components: {
        vueDropzone: vue2Dropzone
    },
}
</script>
<style scoped>
    .dg-btn--ok {
        background-color: #3c8dbc;
        border-color: #367fa9;
        color: #fff;
    }

    .dg-btn--cancel {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }


    #dropzone .dz-preview {
        width: 160px;
        display: inline-block
    }
    #dropzone .dz-preview .dz-image {
        width: 80px;
        height: 80px;
        margin-left: 40px;
        margin-bottom: 10px;
    }
    #dropzone .dz-preview .dz-image > div {
        width: inherit;
        height: inherit;
        border-radius: 50%;
        background-size: contain;
    }
    #dropzone .dz-preview .dz-image > img {
        width: 100%;
    }

    #dropzone .dz-preview .dz-details {
        color: white;
        transition: opacity .2s linear;
        text-align: center;
    }
    #dropzone .dz-success-mark, .dz-error-mark, .dz-remove {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// index.vue?0c72329a